import AddCaseToCart from './AddCaseToCart';
import CompareAtPriceFF from './CompareAtPriceFF';
import Discount from './Discount';
import SalePriceFF from './SalePriceFF';

const Item = (props) => {
  const { product, settings, cart, analytics } = props;
  if (!product.variants || product.variants.length === 0) {
    return null;
  }
  return (
    <div className="c7-product-quickshop__row">
      <div>
        <AddCaseToCart product={product} analytics={analytics} cart={cart} />
      </div>
      <div>
        <a href={`/product/${product.slug}`}>{product.title}</a>
      </div>
      <div>
        <CompareAtPriceFF product={product} settings={settings} />
      </div>
      <div>
        <SalePriceFF product={product} settings={settings} />
      </div>
      <div>
        <Discount product={product} />
      </div>
    </div>
  );
};

export default Item;
